import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Vuelidate from  'vuelidate'

import VueSweetalert2 from 'vue-sweetalert2';

import "./assets/styles.scss"

Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
Vue.config.productionTip = false



new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
